<div *ngIf="featuresToggle.tripPlanner||featuresToggle.itinerary else loading" class="full-height block">
    <ng-container *ngIf="!featuresToggle.itinerary&&(isForTourList||isForSingleTour) else canshow">
        <div class="vertical-middle">
            Oh, snap! It seems this content widget has been disabled or is not properly displaying.
            If you have any questions, please contact the ITI Digital team at support@itidigital.freshdesk.com or call
            us directly at (912) 250-2689.
        </div>
    </ng-container>
    <ng-template #canshow>
        <div class="trip relative" #trip [class.mobile-view]="isMobile">
            <div *ngIf="isShowGDPR&&!isForTourList" class="GDPR-msg" [class.pc-GDPR]="!isMobile">
                <span>When you log in with Google or Facebook, you agree to allow our system to save your trip
                    preferences. We place a cookie to know how each user uses our site and which items they saved on
                    their trip. The data is anonymized to us, and Google or Facebook solely manages your email details.
                    Please let us know if this is okay with you.</span>
                <ig-button size="md" (trigger)="acceptCookie()">Accept Cookies</ig-button>
            </div>

            <div *ngIf="!isMobile&&!featuresToggle.multipleCities&&!isForTourList" class="top-wrap flex relative">
                <ng-container>
                    <div style="width: 220px;margin-right: 24px" class="login-with-fb">
                        <ig-social-login-popup #socialLogin [text]="'Login to save your trips'"
                            (onLoginStatusChanged)="socialLoggedIn($event)">
                        </ig-social-login-popup>
                    </div>
                    <div *ngIf="sidebar&&sidebar.displayingOn==='event'" class="time-range">
                        <ig-date-field [(ngModel)]="from" [max]="to" [min]="today" label="from"
                            (ngModelChange)="filterEvents()" [iconColor]="style.tripPlanner.buttons.color.value">
                        </ig-date-field>
                    </div>
                    <div *ngIf="sidebar&&sidebar.displayingOn==='event'" class="time-range">
                        <ig-date-field [(ngModel)]="to" [min]="from" label="to" (ngModelChange)="filterEvents()"
                            [iconColor]="style.tripPlanner.buttons.color.value">
                        </ig-date-field>
                    </div>
                    <div class="top-input-wrap search-wrap">
                        <form ngForm="searchFormGroup" class="relative"
                            *ngIf="!sidebar||sidebar.displayingOn==='event'||sidebar.displayingOn==='place'">
                            <ig-field igDebounce #searchItem
                                [label]="!sidebar?'Open events or places tab to search items':sidebar.displayingOn==='event'?'search events':'search places'"
                                [isInnerLabel]="true" [isSearch]="true" [formControl]="searchFormGroup.get('search')"
                                icon="search" [(ngModel)]="searchText" (onClear)="clearSearchText()"
                                (debounceKeyup)="search()">
                            </ig-field>
                            <ig-alt-button (trigger)="search()" (cancel)="clearSearchText()"></ig-alt-button>
                        </form>
                        <!--                <ig-search *ngIf="sidebar&&(sidebar.displayingOn==='trip'||sidebar.displayingOn==='tour')" #mobilesearch-->
                        <!--                           [onSearch]="searchItemInTourOrTrip"-->
                        <!--                           [onSearchResultSelected]="searchResultSelectedInTourOrTrip"-->
                        <!--                           placeHolder="search items"></ig-search>-->
                    </div>
                    <ig-powered-by [style]="'iti-vertical'"></ig-powered-by>
                </ng-container>
            </div>

            <ig-row *ngIf="featuresToggle.multipleCities&&!isForTourList" class="top-wrap multi-city-wrap">
                <ng-container>
                    <ig-col [xs]="6" *ngIf="!isMobile" class="top-multi-city-text">
                        <span><span class="hide-on-below-1200">Select the destination, </span>view places of interests
                            and <strong>Add to Trip</strong> to create a custom itinerary</span>
                    </ig-col>
                    <ig-col *ngIf="isMobile" [xs]="12">
                        <div class="top-login-btn" #loginBtnNotLoggedIn>
                            <ig-social-login-popup #socialLogin [text]="'LOGIN TO SAVE YOUR TRIPS'"
                                (onLoginStatusChanged)="socialLoggedIn($event)">
                            </ig-social-login-popup>
                        </div>
                    </ig-col>
                    <ig-col [xs]="12" [md]="6" *ngIf="regionSource">
                        <div class="flex" btns>
                            <ig-select *ngIf="!isMobile" #regionSelect class="region-not-selected"
                                [(ngModel)]="regionSource" (itemSelected)="selectRegion($event)"></ig-select>

                            <ig-search #citySearch [disabled]="false" [onSearch]="searchCity"
                                [onSearchResultSelected]="searchCityResultSelect" placeHolder="cities"></ig-search>
                            <ig-field igDebounce #searchItem label="places" [isInnerLabel]="true"
                                [formControl]="searchFormGroup.get('search')" [icon]="searchText?'clear':'search'"
                                (onIconClick)="clearSearchText()" (debounceKeyup)="search()" [(ngModel)]="searchText">
                            </ig-field>
                            <div class="login-with-fb" [class.multi-city]="isMobile" #loginBtnLoggedIn>
                                <div #loginBtnWrap>
                                    <ig-social-login-popup *ngIf="!isMobile" #socialLogin
                                        [text]="isMobile?'login':'LOGIN TO SAVE YOUR TRIPS'"
                                        (onLoginStatusChanged)="socialLoggedIn($event)"
                                        (onDropdownShow)="closeLoginTip()">
                                    </ig-social-login-popup>
                                    <ng-container *ngIf="isMobile">
                                        <img #profile src="" alt="user profile image" [matMenuTriggerFor]="actionMenu">

                                        <mat-menu #actionMenu="matMenu">
                                            <button mat-menu-item (click)="socialLogin.logout()">Logout</button>
                                        </mat-menu>
                                    </ng-container>
                                </div>
                            </div>

                            <ig-select *ngIf="isMobile" #regionSelect class="region-not-selected"
                                [(ngModel)]="regionSource" (itemSelected)="selectRegion($event)"></ig-select>
                        </div>
                    </ig-col>
                </ng-container>
            </ig-row>

            <ng-container *ngIf="isMobile&&!featuresToggle.multipleCities&&!isForTourList">
                <ig-row class="m-t-1">
                    <div class="flex mobile-top-wrap">
                        <div style="width:84%;display: none" #searchLogginIn>
                            <form ngForm="searchFormGroup">
                                <ig-field igDebounce #searchItem
                                    [label]="!sidebar?'events or places':sidebar.displayingOn==='event'?'search events':'search places'"
                                    [disabled]="!isShowSidebarOnMobile||isSearchDisabled" [isInnerLabel]="true"
                                    [isSearch]="true" [formControl]="searchFormGroup.get('search')" icon="search"
                                    [(ngModel)]="searchText" (onClear)="clearSearchText()" (debounceKeyup)="search()">
                                </ig-field>
                                <!--                            <ig-alt-button (trigger)="search()" (cancel)="clearSearchText()"></ig-alt-button>-->
                            </form>
                        </div>
                        <div style="padding:0 8px;width: 100%" #loginIcon>
                            <ig-social-login-popup #socialLogin [text]="'login to save your trips'"
                                (onLoginStatusChanged)="socialLoggedIn($event)">
                            </ig-social-login-popup>
                        </div>

                    </div>
                    <div class="flex submit-wrap">
                        <ig-button *ngIf="!sidebar||sidebar.displayingOn==='event'" class="m-t-1" size="md"
                            (trigger)="goToSubmitPage('event')">Submit your event</ig-button>
                        <ig-button *ngIf="!sidebar||sidebar.displayingOn==='place'" class="m-t-1" size="md"
                            (trigger)="goToSubmitPage('place')">Submit your place</ig-button>
                    </div>
                </ig-row>
                <ig-row>
                    <ig-col [xs]="12">
                        <div #searchNotLoggedIn class="not-login-search">
                            <form ngForm="searchFormGroup">
                                <ig-field igDebounce #searchItem
                                    [label]="!sidebar?'Open events or places tab to search items':sidebar.displayingOn==='event'?'search events':'search places'"
                                    [disabled]="!isShowSidebarOnMobile||isSearchDisabled" [isInnerLabel]="true"
                                    [isSearch]="true" [formControl]="searchFormGroup.get('search')" icon="search"
                                    [(ngModel)]="searchText" (onClear)="clearSearchText()" (debounceKeyup)="search()">
                                </ig-field>
                                <!-- <ig-alt-button (trigger)="search()" (cancel)="clearSearchText()"></ig-alt-button> -->
                            </form>
                        </div>
                    </ig-col>
                </ig-row>
            </ng-container>

            <div *ngIf="featuresToggle.multipleCities&&isMultiCityBlock&&!isForTourList" class="mobile-block-nav-wrap">
                <ig-spinner *ngIf="loadingRegion"></ig-spinner>
                <ig-block-navigator #blockNavigator *ngIf="!loadingRegion"
                    [items]="currentRegion?currentRegion.cities:[]"
                    (onCityClick)="gotoCity($event)"></ig-block-navigator>
            </div>

            <ng-container *ngIf="(!featuresToggle.multipleCities)||(featuresToggle.multipleCities&&!noCities)">
                <ig-row [class.tour-list-wrap]="isForTourList" [class.side-bar-row]="isShowSidebarOnMobile"
                    style="position: initial">
                    <div *ngIf="isForTourList&&!isForSingleTour" class="tour-list-title">
                        <ng-container *ngIf="!isMobile">
                            <div titlewrap
                                [ngStyle]="{'paddingTop':(isShowNormalMap||isShowDirectionMap)?'14px':'20px'}">
                                <span>EXPLORE OUR SUGGESTED ITINERARIES</span>
                                <ig-button *ngIf="isShowNormalMap||isShowDirectionMap" class="tour-back m-l-3"
                                    style="display: inline-block" (trigger)="sidebar.switchToTours()" size="md">
                                    Back to all
                                </ig-button>
                            </div>
                            <ig-powered-by [style]="'iti-vertical'"></ig-powered-by>
                        </ng-container>
                        <!-- <div *ngIf="isMobile" class="flex">
                            <div titlewrap>
                                <p>EXPLORE OUR ITINERARIES</p>
                            </div>
                            <div *ngIf="hubName!==EurekaCA">
                                <ig-powered-by [style]="'iti-vertical'"></ig-powered-by>
                            </div>
                        </div> -->
                        <div *ngIf="isMobile" style="height: 40px;text-align: center;width:100%;padding-top:16px">
                            <p>EXPLORE OUR ITINERARIES</p>
                        </div>
                    </div>
                    <ig-col *ngIf="!isMobile||(isMobile&&isShowSidebarOnMobile)"
                        [md]="isMobile?12:isShowingEventOrPlace?isSmallestPC?8:7:4" [xs]="12"
                        class="trip-side-bar-wrap">
                        <ig-visitor-trip-side-bar #sidebar (hideMap)="hideMap()"
                            (onFloatDetailShown)="isShowFloatDetail=true;isShowfloatDetailPlaceFeeds=false"
                            (onFloatDetailClosed)="isShowFloatDetail=false;isShowfloatDetailPlaceFeeds=false"
                            (onFloatDetailFeedsClosed)="isShowfloatDetailPlaceFeeds=false"
                            (onFloatDetailPlaceFeedsRetrieved)="floatDetailPlaceFeedsRetrieved($event)"
                            (onMapReady)="mapReady()" (showInfoWindowOnMap)="showOnMap($event)"
                            (tripListReordered)="reorder($event)" (showTourWaterfall)="showTours($event)"
                            (removeFromTripEvent)="afterRemoveFromTrip($event)"></ig-visitor-trip-side-bar>
                    </ig-col>
                    <ig-col [ngStyle]="{'width':placeHolderWidth}"></ig-col>
                    <ig-col *ngIf="!isShowSidebarOnMobile" [ngStyle]="{'width':mapSectionWidth}" class="bg-wrap">
                        <div #bg class="full-height">
                            <!--                        <ng-container *ngIf="!isShowDirectionMap&&!isShowNormalMap&&!isShowTour">-->
                            <ng-container *ngIf="isMobile">
                                <ig-image [imageUrl]="tpHomeImageUrl||welcomeImg"
                                    alt="trip planner background picture"></ig-image>

                                <p class="intro">
                                    It's time to hit the road! Explore restaurants, attractions, shopping, and more
                                    points of interest. Add sites to do and see, save your trip, print, or share to get
                                    started. Start planning today!
                                </p>

                                <div class="flex icon-row">
                                    <div (click)="showEvents()" role="button" aria-label="go to events">
                                        <mat-icon class="event-icon"
                                            [style.backgroundColor]="style.tripPlanner.event.color.value">date_range</mat-icon>
                                        <span role="button">Events</span>
                                    </div>
                                    <div (click)="showPlaces()" role="button" aria-label="go to places">
                                        <mat-icon class="place-icon"
                                            [style.backgroundColor]="style.tripPlanner.place.color.value">room</mat-icon>
                                        <span>Places</span>
                                    </div>
                                    <div *ngIf="featuresToggle.itinerary" (click)="showToursView()" role="button"
                                        aria-label="go to itineraries">
                                        <mat-icon class="tour-icon"
                                            [style.backgroundColor]="style.tripPlanner.tour.color.value">directions_car</mat-icon>
                                        <span>Itineraries</span>
                                    </div>
                                    <div *ngIf="featuresToggle.tripPlanner" (click)="showTrips()" role="button"
                                        aria-label="go to my trips">
                                        <mat-icon class="trip-icon"
                                            [style.backgroundColor]="style.tripPlanner.trip.color.value">work</mat-icon>
                                        <span>My Trips</span>
                                    </div>
                                </div>

                                <ig-row>
                                    <ig-col [md]="2"></ig-col>
                                    <ig-col [md]="12" [lg]="8" [xs]="12">
                                        <ig-row class="start-row">
                                            <ig-col [md]="4" [lg]="4" [xs]="6">
                                                <ig-date-field [(ngModel)]="from" [max]="to" [min]="today" label="from"
                                                    (ngModelChange)="filterEvents()"
                                                    [iconColor]="style.tripPlanner.buttons.color.value">
                                                </ig-date-field>
                                            </ig-col>
                                            <ig-col [md]="4" [lg]="4" [xs]="6" class="to-datepicker">
                                                <ig-date-field [(ngModel)]="to" [min]="from" label="to"
                                                    (ngModelChange)="filterEvents()"
                                                    [iconColor]="style.tripPlanner.buttons.color.value">
                                                </ig-date-field>
                                            </ig-col>
                                            <ig-col [md]="4" [lg]="4" [xs]="12" class="p-l-0">
                                                <ig-button class="trip-start" (trigger)="start()"
                                                    [style.background]="style.tripPlanner.buttons.color.value">start</ig-button>
                                            </ig-col>
                                        </ig-row>
                                        <ig-row *ngIf="isShowWelcomepageNoEventTip" class="no-event-wrap">
                                            <span>Oh no! Looks like there are no upcoming events for these days, but you
                                                can still add <span link
                                                    (click)="sidebar.switchToPlaces();scrollToTop()">Places</span> to
                                                your trip and also review our <span link
                                                    (click)="sidebar.switchToTours();scrollToTop()">Suggest
                                                    Itineraries</span>.
                                            </span>
                                        </ig-row>
                                    </ig-col>
                                    <ig-col [md]="2"></ig-col>
                                </ig-row>
                            </ng-container>
                            <ng-container *ngIf="isShowDirectionMap">
                                <ig-direction-plan #direction [tour]="tripTour" [type]="sidebar.displayingOn"
                                    (showDetail)="gotoDetails($event)" (enterFirstTrip)="sidebar.enterTrip(0)"
                                    (mapClick)="sidebar.attractionlist.detailsPanel.closeDetails()"
                                    (onStart)="isPlanStarted=true" (onEnd)="isPlanStarted=false"></ig-direction-plan>
                                <div *ngIf="!isPlanStarted&&sidebar.displayingOn==='tour'&&!isForSingleTour"
                                    class="tour-back" (click)="sidebar.switchToTours()">
                                    <mat-icon>chevron_left</mat-icon>
                                    Back
                                </div>
                            </ng-container>
                            <ng-container *ngIf="isShowNormalMap">
                                <agm-map #map [styles]="hideIconMapStyler" [clickableIcons]="false"
                                    [latitude]="items&&items.length===1?items[0].address.lat:lat"
                                    [longitude]="items&&items.length===1?items[0].address.lng:lng"
                                    [mapTypeId]="'terrain'" [zoom]="!items.length?4:items.length===1?18:0"
                                    [fitBounds]="latLngBounds" (mapClick)="sidebar.detailsPanel.closeDetails()">
                                    <agm-marker *ngFor="let geo of items; let i = index" [latitude]="geo.address.lat"
                                        [longitude]="geo.address.lng"
                                        [iconUrl]="geo.mapIcon?imageService.imageSourceUrl(placeMapIcon[geo.mapIcon]):null"
                                        (mouseOver)="showInfoWindowByIndex(i)">

                                        <agm-snazzy-info-window [isOpen]="isInfoWindowsOpen[i]"
                                            [closeWhenOthersOpen]="true" (afterClose)="hideAllSingleInfoWindow()">
                                            <ng-template>
                                                <div class="relative">
                                                    <div class="map-event-title">
                                                        {{geo.title || geo.name}}
                                                    </div>
                                                    <div *ngIf="!isShowFloatDetail" class="map-event-img">
                                                        <!--<img [src]="imageService.safeImage(imageService.imageSource(geo))">-->
                                                        <ig-image [imageUrl]="geo.cover?.source" alt="event"></ig-image>
                                                    </div>
                                                    <div class="map-event-time">
                                                        <div *ngIf="geo.eventTimes&&geo.eventTimes.length>1">
                                                            <ng-container *ngIf="!geo.startTimeText">
                                                                <p *ngFor="let eventTime of geo.eventTimes">
                                                                    {{eventTime.startTimeFormatted}}{{eventTime.endTimeFormatted
                                                                    ? '
                                                                    -
                                                                    '+eventTime.endTimeFormatted:''}}
                                                                </p>
                                                            </ng-container>
                                                            <ng-container *ngIf="geo.startTimeText">
                                                                <p *ngFor="let eventTime of geo.eventTimesText">
                                                                    {{eventTime.startTimeText +
                                                                    geo.timezone}}{{eventTime.endTimeText ? '
                                                                    -
                                                                    '+eventTime.endTimeText+geo.timezone:''}}
                                                                </p>
                                                            </ng-container>

                                                        </div>
                                                        <div *ngIf="!geo.eventTimes||geo.eventTimes.length<=1">
                                                            <ng-container *ngIf="!geo.startTimeText">
                                                                {{geo.startTimeFormatted}}{{geo.endTimeFormatted ? ' -
                                                                '+geo.endTimeFormatted:''}}
                                                            </ng-container>
                                                            <ng-container *ngIf="geo.startTimeText">
                                                                {{geo.startTimeText + geo.timezone}}{{geo.endTimeText ?
                                                                ' -
                                                                '+geo.endTimeText+geo.timezone:''}}
                                                            </ng-container>
                                                        </div>
                                                        <div *ngIf="!geo.startTime&&geo.address&&geo.address.address">
                                                            {{geo.address.address}}
                                                        </div>
                                                    </div>
                                                    <ig-button class="event-btn" (trigger)="gotoDetails(geo)">
                                                        DETAILS
                                                    </ig-button>
                                                </div>
                                            </ng-template>
                                        </agm-snazzy-info-window>
                                    </agm-marker>
                                </agm-map>
                            </ng-container>
                            <ng-container *ngIf="isShowTour&&!isShowDirectionMap">
                                <ig-water-fall-container #waterFallContainer [hidden]="isNoContent" [itemWidth]="300"
                                    [maxColumnCount]="3" [isHideSpinner]="true" [isAllItemsLoaded]="isAllDataLoaded"
                                    (onLoadMore)="loadMore()">
                                    <ng-container>
                                        <ig-visitor-tour-card *ngFor="let tour of tours" [tour]="tour"
                                            [titleBgColor]="style.tripPlanner.tour.color.value"
                                            (showDetail)="showTourDetail(tour)"></ig-visitor-tour-card>
                                    </ng-container>
                                </ig-water-fall-container>

                                <ng-container>
                                    <ig-page-spinner #spinner></ig-page-spinner>
                                </ng-container>

                                <ig-no-content *ngIf="isNoContent"></ig-no-content>
                            </ng-container>
                        </div>

                    </ig-col>
                </ig-row>
            </ng-container>

            <!--    <div *ngIf="!isMobile" class="ada">Important notice: This page does not conform, but would conform to WCAG 2.1 if-->
            <!--        the following parts from uncontrolled sources were removed. In addition, this website is not the author of-->
            <!--        content of this third-party widget.-->
            <!--    </div>-->

        </div>

        <div #div *ngIf="isMobile&&(isShowNormalMap||isShowDirectionMap)" class="trip trip-mobile">

            <div class="ig-back" (click)="hidePopup()">
                <div>
                    <mat-icon *ngIf="isNormalMapReady">keyboard_backspace</mat-icon>
                    <span>{{!isNormalMapReady ? 'LOADING THE MAP...' : 'TAKE ME BACK'}}</span>
                </div>
            </div>

            <ng-container *ngIf="isShowNormalMap">
                <agm-map #map [latitude]="items&&items.length===1?items[0].address.lat:lat"
                    [longitude]="items&&items.length===1?items[0].address.lng:lng" (mapReady)="normalMapReady()"
                    [mapTypeId]="'terrain'" [zoom]="!items.length?4:items.length===1?18:0" [fitBounds]="latLngBounds">
                    <agm-marker *ngFor="let geo of items; let i = index" [visible]="geo!==mapBottomInfoItem"
                        [latitude]="geo.address.lat" [longitude]="geo.address.lng"
                        [iconUrl]="geo.mapIcon?imageService.imageSourceUrl(placeMapIcon[geo.mapIcon]):null"
                        (markerClick)="mapMarkerClick(geo)">

                        <agm-snazzy-info-window *ngIf="!isMobile" [isOpen]="isInfoWindowsOpen[i]"
                            [closeWhenOthersOpen]="true" (afterClose)="hideAllSingleInfoWindow()">
                            <ng-template>
                                <div class="relative">
                                    <div class="map-event-title">
                                        {{geo.title}}
                                    </div>
                                    <div class="map-event-img">
                                        <!--<img [src]="imageService.safeImage(imageService.imageSource(geo))">-->
                                        <ig-image [imageUrl]="geo.cover?.source" alt="event"></ig-image>
                                    </div>
                                    <div class="map-event-time">
                                        <div *ngIf="geo.eventTimes&&geo.eventTimes.length>1">
                                            <ng-container *ngIf="!geo.startTimeText">
                                                <p *ngFor="let eventTime of geo.eventTimes">
                                                    {{eventTime.startTimeFormatted}}{{eventTime.endTimeFormatted ? ' -
                                                    '+eventTime.endTimeFormatted:''}}
                                                </p>
                                            </ng-container>
                                            <ng-container *ngIf="geo.startTimeText">
                                                <p *ngFor="let eventTime of geo.eventTimesText">
                                                    {{eventTime.startTimeText + geo.timezone}}{{eventTime.endTimeText ?
                                                    ' -
                                                    '+eventTime.endTimeText+geo.timezone:''}}
                                                </p>
                                            </ng-container>

                                        </div>
                                        <div *ngIf="!geo.eventTimes||geo.eventTimes.length<=1">
                                            <ng-container *ngIf="!geo.startTimeText">
                                                {{geo.startTimeFormatted}}{{geo.endTimeFormatted ? ' -
                                                '+geo.endTimeFormatted:''}}
                                            </ng-container>
                                            <ng-container *ngIf="geo.startTimeText">
                                                {{geo.startTimeText + geo.timezone}}{{geo.endTimeText ? ' -
                                                '+geo.endTimeText+geo.timezone:''}}
                                            </ng-container>
                                        </div>
                                    </div>
                                    <ig-button class="event-btn" (trigger)="gotoDetails(geo)">
                                        DETAILS
                                    </ig-button>
                                </div>
                            </ng-template>
                        </agm-snazzy-info-window>
                    </agm-marker>

                    <agm-marker *ngIf="mapBottomInfoItem" [iconUrl]="detailSelectedMapMarker" [zIndex]="9"
                        [latitude]="mapBottomInfoItem.address.lat||mapBottomInfoItem.lat"
                        [longitude]="mapBottomInfoItem.address.lng||mapBottomInfoItem.lng"></agm-marker>
                </agm-map>
                <ig-trip-map-bottom-info #mapBottomInfo *ngIf="mapBottomInfoItem" [item]="mapBottomInfoItem"
                    [isShowRemoveBtn]="false" [index]="mapBottomInfoIndex"
                    (showDetail)="gotoDetails(mapBottomInfoItem)"></ig-trip-map-bottom-info>

            </ng-container>

            <ng-container *ngIf="isShowDirectionMap">
                <ig-direction-plan #direction [tour]="tripTour" [type]="sidebar.displayingOn"
                    (showDetail)="gotoDetails($event)" (removeFromTrip)="removeFromTrip($event)"
                    (mapReady)="normalMapReady()" (onStart)="startPlan()"
                    (onEnd)="isPlanStarted=false"></ig-direction-plan>
            </ng-container>

        </div>

        <div #loginTip
            style="position: absolute; width:100%;height:100%;background-color: black;opacity: 0.8;z-index: 99;top:0;display: none"
            (click)="closeLoginTip()">
            <div style="color:white;font-size: 18px;text-align: center;width: 100%;margin-top: 55px">Login to save your
                trips
            </div>
<!--            <img [src]="arrowImg" alt="login tip" style="width: 12%;right:5%;top:44px;position: absolute">-->
        </div>
    </ng-template>


</div>

<ng-template #loading>
    <!--<div *ngIf="!featuresToggle.tripPlanner" class="vertical-middle">-->
    <div class="vertical-middle">
        Oh, snap! It seems this content widget has been disabled or is not properly displaying.
        If you have any questions, please contact the ITI Digital team at support@itidigital.freshdesk.com or call us
        directly at (912) 250-2689.
    </div>
</ng-template>


<ig-page-spinner class="trip-spinner" #pagespinner [loadingTip]="loadingTip" [diameter]="26"></ig-page-spinner>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/trip/visitor.trip.component.html